import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {

  // 👤 SAME USER LOGIC (DON'T TOUCH)
  const [user, setUser] = useState(() => {
    try {
      const storedUser = localStorage.getItem("studyportal_user");
      return storedUser ? JSON.parse(storedUser) : null;
    } catch {
      return null;
    }
  });

  // ⏳ ONLY ADDITION (NO LOGIC CHANGE)
  const [loading, setLoading] = useState(true);

  // 🔐 SAME LOGIN (DON'T TOUCH)
  const login = (data) => {
  if (!data) return;

  const role = data.role;
  if (role !== "user" && role !== "admin") return;

  setUser(data);
  localStorage.setItem("studyportal_user", JSON.stringify(data));
};


  // 🔐 SAME LOGOUT (DON'T TOUCH)
  const logout = () => {
    setUser(null);
    localStorage.removeItem("studyportal_user");
  };

  // 🔄 SAME EFFECT + ONLY 1 LINE ADD
  useEffect(() => {
    if (user) {
      localStorage.setItem("studyportal_user", JSON.stringify(user));
    }
    setLoading(false); // ✅ ADD THIS LINE ONLY
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
